import logoLight from "../../assets/images/logoLight.svg";
import { FaWhatsapp } from "react-icons/fa";
import { SITE } from "../../constants/site";
import { getMainSiteUrl } from "../../constants/appConfig";
import { isRtlLanguage } from "../../utils/i18n";
import { useTranslation } from "react-i18next";
import "../layout/NavBar.css";
import "./LandingLogoNav.css";

function LandingLogoNav() {
  const { t, i18n } = useTranslation();
  const isRtl = isRtlLanguage(i18n.language);
  const contactUrl = `${getMainSiteUrl()}/Contact`;

  return (
    <header className="caf-site-nav landing-logo-nav" dir={isRtl ? "rtl" : "ltr"}>
      <div className="landing-logo-nav__inner">
        <img src={logoLight} alt={SITE.name} className="caf-site-nav__logo landing-logo-nav__logo" />

        <div className="landing-logo-nav__actions">
          <a
            href={`https://wa.me/${SITE.whatsappNumber.replace(/\D/g, "")}`}
            className="landing-logo-nav__action landing-logo-nav__action--whatsapp"
            target="_blank"
            rel="noopener noreferrer"
          >
            <FaWhatsapp aria-hidden="true" />
            <span className="landing-logo-nav__action-label">{t("WhatsApp")}</span>
          </a>
          <a href={contactUrl} className="landing-logo-nav__action landing-logo-nav__action--contact">
            {t("Contact Us")}
          </a>
        </div>
      </div>
    </header>
  );
}

export default LandingLogoNav;
